import * as firebase from 'firebase';

import {
  getOrderPageFromFirebase,
  updateOrderToFirebase,
  deleteOrderFromFirebase,
  getOrdersFromRef
} from '../utils/orderService';

export const GET_ORDERS_DATA = 'GET_ORDERS_DATA';
export const GET_ORDERS_DATA_SUCCESS = 'GET_ORDERS_DATA_SUCCESS';
export const GET_ORDERS_DATA_FAILURE = 'GET_ORDERS_DATA_FAILURE';

export const UPDATE_ORDER = 'UPDATE_ORDER';
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS';
export const UPDATE_ORDER_FAILURE = 'UPDATE_ORDER_FAILURE';

export const DELETE_ORDER = 'DELETE_ORDER';
export const DELETE_ORDER_SUCCESS = 'DELETE_ORDER_SUCCESS';
export const DELETE_ORDER_FAILURE = 'DELETE_ORDER_FAILURE';

export const GET_ACTIVE_ORDERS = 'GET_ACTIVE_ORDERS';
export const GET_ACTIVE_ORDERS_SUCCESS = 'GET_ACTIVE_ORDERS_SUCCESS';
export const GET_ACTIVE_ORDERS_FAILURE = 'GET_ACTIVE_ORDERS_FAILURE';

export const GET_USER_ORDERS = 'GET_USER_ORDERS';
export const GET_USER_ORDERS_SUCCESS = 'GET_USER_ORDERS_SUCCESS';
export const GET_USER_ORDERS_FAILURE = 'GET_USER_ORDERS_FAILURE';

export function getActiveOrders(){
  return async (dispatch) => {
    dispatch({ type: GET_ACTIVE_ORDERS })
    try {
      const data = await getActiveOrdersFromDatabase()
      return dispatch({ type: GET_ACTIVE_ORDERS_SUCCESS, payload: { orders: data } })
    } catch(e) {
      return dispatch({ type: GET_ACTIVE_ORDERS_FAILURE, payload: { error: e } })
    }
  }
}


export function getUserOrders({ userKey }){
  return async (dispatch) => {
    dispatch({ type: GET_USER_ORDERS });
    try {
      const ordersPromise = await getUserOrdersFromFirebase(userKey);
      const orders = await ordersPromise;
      return dispatch({ type: GET_USER_ORDERS_SUCCESS, payload: { orders: orders.reverse() }})
    } catch(e) {
      return dispatch({ type: GET_USER_ORDERS_FAILURE, payload: { error: e }})
    }
  }
}


function getActiveOrdersFromDatabase(){
  const ref = firebase.database().ref().child('cart_sessions').orderByChild('active').equalTo(true)
  return getOrdersFromRef(ref)
}

export function getOrderPage({ limit, page }){
  return async (dispatch) => {
    dispatch({ type: GET_ORDERS_DATA })
    try {
      const data = await getOrderPageFromFirebase({ limit, page })
      return dispatch({ type: GET_ORDERS_DATA_SUCCESS, payload: { orders: data } })
    } catch(e) {
      return dispatch({ type: GET_ORDERS_DATA_FAILURE, payload: { error: e } })
    }
  }
}

export function updateOrder({ key, data }){
  return async (dispatch) => {
    dispatch({ type: UPDATE_ORDER })
    try {
      const order = await updateOrderToFirebase({ key, data })
      return dispatch({ type: UPDATE_ORDER_SUCCESS, payload: { order } })
    } catch(e) {
      return dispatch({ type: UPDATE_ORDER_FAILURE, payload: { error: e } })
    }
  }
}

export function deleteOrder({ key }){
  return async (dispatch) => {
    dispatch({ type: DELETE_ORDER });
    try {
      const order = await deleteOrderFromFirebase({ key });
      return dispatch({ type: DELETE_ORDER_SUCCESS, payload: { order } });
    } catch (e) {
      return dispatch({ type: DELETE_ORDER_FAILURE, payload: { error: e } });
    }
  }
}


function getUserOrdersFromFirebase(userKey){
  return new Promise((resolve, reject) => {
    firebase.database().ref().child('orders').orderByKey().on('value', async orders => {
      const orderList = [];
      orders.forEach(order => {
        if (order.val() === userKey) {
          orderList.push(order.key)
        }
      })
      const newOrderList = orderList.map(key => {
        return new Promise((resolve, reject) => {
          firebase.database().ref().child('cart_sessions').child(key).on('value', cart => {
            resolve({...cart.val(), key: cart.key });
          })
        })
      })

      resolve(Promise.all(newOrderList));
    })
  }) 
}



// WEBPACK FOOTER //
// ./src/actions/orderActions.js